// Formats a 24-hour "HH:MM" time from business.json as "h:MM AM/PM".
export const formatTime = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  const suffix = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 === 0 ? 12 : hours % 12;
  return `${displayHours}:${String(minutes).padStart(2, "0")} ${suffix}`;
};

// business.json lists hours Monday-first; Date.getDay() counts from Sunday = 0.
export const jsDayIndex = (day) =>
  ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].indexOf(day);
